// Wrapper around our Typography Text
import withTypography from './withTypography'
import MindfulText from '../components/ui/Typography/MindfulText'

export default withTypography(MindfulText)
